import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=ce79b246&"
import script from "./Control.vue?vue&type=script&lang=js&"
export * from "./Control.vue?vue&type=script&lang=js&"
import style0 from "./Control.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QIcon,QSlider,QSelect,QPopupProxy,QColor,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QIcon,QSlider,QSelect,QPopupProxy,QColor,QBtn})
